import { type Action, createStore } from 'react-sweet-state';

export interface State {
  // The saved item under the mouse.
  activeVariationInstanceId: string | null;
  detailsPanelVisibleForInstanceId: string | null;
}

export type Actions = typeof ACTIONS;

const INITIAL_STATE: State = {
  activeVariationInstanceId: null,
  detailsPanelVisibleForInstanceId: null,
};

export const PRIVATE_ACTIONS = {
  init:
    (): Action<State> =>
    ({ setState }) => {
      setState(INITIAL_STATE);
    },
};

const ACTIONS = {
  activateVariation:
    (instanceId: string | null): Action<State> =>
    ({ setState }) => {
      setState({ activeVariationInstanceId: instanceId });
    },

  openVariationDetailsPanel:
    (instanceId: string): Action<State> =>
    ({ setState }) => {
      setState({ detailsPanelVisibleForInstanceId: instanceId });
    },

  closeVariationDetailsPanel:
    (): Action<State> =>
    ({ setState }) => {
      setState({ detailsPanelVisibleForInstanceId: null });
    },
};

export const ReadonlyDocumentScoresStore = createStore<State, Actions>({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: 'ReadonlyDocumentScores',
});
